import React, {ReactNode} from 'react';
import style from './style.module.scss';

type TGalleryOverlayBarProps = {
    leftSlot: ReactNode;
    rightSlot: ReactNode;
};

export const GalleryOverlayBar = (props: TGalleryOverlayBarProps) => {
    const {leftSlot, rightSlot} = props;

    return (
        <div className={style.main}>
            <div className={style.left}>{leftSlot}</div>
            <div className={style.right}>{rightSlot}</div>
        </div>
    );
};
